/**
 * Utility functions to check for certain experiment strings
 * fetched via the /core/session/config/ (can access via useCosmos())
 */

import { TSessionConfigData } from 'providers/contexts/CosmosContext';
import { GetUserMeData } from 'utility/types/dataProvider';

/**
 * Session Config Experiment Strings
 * All Session Config Experiments combined
 */
export type TSessionConfigExperiments =
  /** These we know are for NXT */
  | 'activity_stream'
  | 'cosmos_tiptap_collaboration'
  | 'cosmos_tiptap_comments'
  | 'dashboard_demo_mode'
  | 'dummy_ltv'
  | 'google_pay_test'
  | 'nxt_copilot_local'
  | 'nxt_beta_program'
  | 'nxt_collaboration_autosave'
  | 'nxt_collaboration'
  | 'nxt_comments'
  | 'nxt_copilot'
  | 'nxt_webmcp'
  | 'nxt_save_asset_rework'
  | 'subscription_solr_indexing'
  | 'subscription_solr_searching'
  /** These others pulled from QAs Blox Experiments Spreadsheet */
  | 'ac_disable_untrusted'
  | 'access_control_fingerprint'
  | 'access_laterpay'
  | 'access_method_legacy'
  | 'access_methods_legacy'
  | 'access_offers'
  | 'admanager_curve'
  | 'adowl_entry_wizard'
  | 'ads_bidding_refresh'
  | 'ads_dfp_adlightning'
  | 'ads_dfp_optimera'
  | 'ads_dfp_sizemapping'
  | 'ads_dfp_smart'
  | 'ads_gam_dmp'
  | 'ads_gam_email'
  | 'ads_gam_safeframe'
  | 'ads_gam_userstitch'
  | 'ads_gdpr'
  | 'ads_mobile_refresh'
  | 'ads_prebid'
  | 'ads_zeus'
  | 'allow_ai_bot_indexing'
  | 'allow_inline_scripts'
  | 'amp_fallback_img'
  | 'amp_gdpr_bypass'
  | 'anti_csrf_tokens'
  | 'ap_broadcast_summary_body'
  | 'ap_import_no_flag'
  | 'app_disable_untrusted'
  | 'app_iapsandbox'
  | 'app_notifications'
  | 'app_untrusted_experimental'
  | 'apple_pay'
  | 'appman_development'
  | 'appman_fcm_token_validity'
  | 'appman_prerelease'
  | 'appman_subscriber_channels'
  | 'asset_preview_proxy'
  | 'autotag_cogito'
  | 'behavioral_recommendations'
  | 'bitcentral_ad'
  | 'bitcentral_ad_method_2'
  | 'bitcentral_floating'
  | 'broadcast_built_in_apps'
  | 'browser_compatibility_modal'
  | 'business_directory_enable_reports'
  | 'business_directory_search_solr'
  | 'business_directory_store_solr'
  | 'business_directory_storefront'
  | 'canonical_test'
  | 'cls_landing_beta'
  | 'cls_search_full'
  | 'cls_zr_backfill'
  | 'component_load_video'
  | 'concurrent_relationships'
  | 'constant_contact_extended_logs'
  | 'content_encryption'
  | 'cs1377_parsely'
  | 'dedupe_pinned_assets'
  | 'disable_csrf_tokens'
  | 'disable_request_counter'
  | 'disable_rfc_redirect'
  | 'disable_strip_scripts'
  | 'disabled_request_counter'
  | 'disabledAdShardingRequiresV'
  | 'disabledCheckLinkModification'
  | 'disabledLegacyOpen'
  | 'disableLegacyOpen'
  | 'dmp_enable_lightning_tag'
  | 'editorial_asset_drafts'
  | 'editorial_crop_hints'
  | 'edt_breakout_regions'
  | 'edt_collection_mapped'
  | 'edt_infinity_story'
  | 'edt_mapped_collection'
  | 'edt_news_nirvana'
  | 'edt_nowapp'
  | 'edt_nowapp_development'
  | 'edt_restore_ad_col'
  | 'edt_video_premium'
  | 'eedition_force_pageviews'
  | 'eedition_pdf_restriction'
  | 'eedition-qr-code-extraction'
  | 'eeditions_segmenting_provider_7con'
  | 'email_reach_modern_format'
  | 'enable_app_analytics'
  | 'enable_base_href'
  | 'enable_decline_logic'
  | 'enable_gtm_start'
  | 'enable_hsts'
  | 'enable_hsts_preload'
  | 'enable_nowapp_analytics'
  | 'enable_subscribe_with_google'
  | 'enable_trust'
  | 'enabledAutoAcceptOwnership'
  | 'enabledAutomatedProduction'
  | 'enabledCaptionCreditOrdering'
  | 'enabledDistributedProduction'
  | 'enabledMaintainAdsPriorToPenultimateProcess'
  | 'enabledPDFAds'
  | 'enabledSpanishFolioTextVariables'
  | 'enabledTifAds'
  | 'enabledYYYY-MM-DDadSharding'
  | 'expertai_modern'
  | 'expose_pii_email_jwt'
  | 'expose_pii_name_jwt'
  | 'field59_native_video_nowapp'
  | 'field59_native_video_web'
  | 'force_video_transcode'
  | 'frame_policy_force_allow'
  | 'fwk_bootstrap'
  | 'google_extended_access'
  | 'google_ima_dai'
  | 'google_ima_demo'
  | 'google_news_sitemap_beta'
  | 'google_pay'
  | 'google_showcase'
  | 'grid_defender'
  | 'image_proxy_preview_nogen'
  | 'image_proxy_preview_template_bypass'
  | 'img_lqip'
  | 'last-modified-editorial'
  | 'maps_use_latlng'
  | 'mega_search'
  | 'most_popular_by_di'
  | 'native_ad_free_experience_lee'
  | 'native_appman_colors'
  | 'native_appsflyer_tracking'
  | 'native_bitcentral'
  | 'native_collections_html'
  | 'native_customer_io'
  | 'native_eedition_images'
  | 'native_eedition_release'
  | 'native_eedition_tab'
  | 'native_endpoint'
  | 'native_facebook_app_events'
  | 'native_html_rendering'
  | 'native_login'
  | 'native_marketing_your_stories'
  | 'native_newsletters_subscription_hide'
  | 'native_nielsen_tracking'
  | 'native_remove_registration'
  | 'native_section_slider_default'
  | 'native_srcset'
  | 'native_srcset_all'
  | 'native_srcset_lazy'
  | 'native_trinity_audio_remove'
  | 'native_web_login'
  | 'neustar_enabled'
  | 'new_podcast'
  | 'new_renewal'
  | 'newscycle_dsi_verify_delivery'
  | 'notifier_optional_titles'
  | 'nxt_proof_reader'
  | 'nxt_style_guide'
  | 'offer_display_promo_search'
  | 'offers_in_page'
  | 'old_renewal'
  | 'opensearch_editorial_embedding'
  | 'opensearch_editorial_read'
  | 'opensearch_editorial_write'
  | 'opt_sections'
  | 'ot_ignore_scripts'
  | 'owl_carousel'
  | 'paywall_audio'
  | 'paywall_collection'
  | 'paywall_flash'
  | 'paywall_html'
  | 'paywall_image'
  | 'paywall_pdf'
  | 'paywall_poll'
  | 'paywall_promo'
  | 'paywall_promos'
  | 'paywall_promos_vanilla'
  | 'paywall_table'
  | 'paywall_video'
  | 'paywall_youtube'
  | 'paywall_zip'
  | 'photo_sales_gooten'
  | 'photo_sales_multiple'
  | 'plugin_jquery_cookie'
  | 'premium_coupon'
  | 'public_cache_ttl'
  | 'purchase_require_billing_location'
  | 'recaptcha_enterprise'
  | 'revert_to_owlcarousel'
  | 'rtest'
  | 'search_redesign'
  | 'secure_cookies'
  | 'subscribe_with_google'
  | 'subscription_aam_track_unrestricted'
  | 'subscription_content_mask'
  | 'subscription_deferred'
  | 'subscription_heartbeat_nobind'
  | 'subscription_legacy'
  | 'subscription_next'
  | 'subscription_purchase_workflow'
  | 'subscription_sca'
  | 'subscription_services_legacy'
  | 'subscription_three'
  | 'subscription_vaulted_renewal'
  | 'susbcription_solr_indexing'
  | 'syncronex'
  | 'syncronex_auto'
  | 'syndicate_match_on_externals'
  | 'syndicate_optimize_asset_save'
  | 'test'
  | 'testcase'
  | 'textrazor-editorial'
  | 'tpl_encapsulate'
  | 'trk_google_tag_manager'
  | 'url_config_use_primary'
  | 'user_live_login'
  | 'user_search_solr'
  | 'userstitch'
  | 'util_fontawesome'
  | 'viafoura_beta'
  | 'video_3d_new'
  | 'video_ccfix'
  | 'video_deferload'
  | 'video_latest'
  | 'video_live'
  | 'video_slideshow'
  | 'video_unstable'
  | 'video_vjs7'
  | 'video_webcomponent'
  | 'videoPhase1'
  | 'vjs_carousel'
  | 'wc_tn-img'
  | 'wc_tn-video'
  | 'weather_metric'
  | 'webauthn';

export type AllExperiments = TSessionConfigExperiments[] | undefined;
type SomeExperiments = TSessionConfigExperiments[];

const commentsKeys: SomeExperiments = ['cosmos_tiptap_comments', 'nxt_comments'];

const collabKeys: SomeExperiments = ['cosmos_tiptap_collaboration', 'nxt_collaboration'];

const collabAutosaveKeys: SomeExperiments = ['nxt_collaboration_autosave'];

const betaProgramKeys: SomeExperiments = ['nxt_beta_program'];

const copilotKitKeys: SomeExperiments = ['nxt_copilot'];

const copilotLocalKeys: SomeExperiments = ['nxt_copilot_local'];

const assetSaveReworkKeys: SomeExperiments = ['nxt_save_asset_rework'];

const openSearchEditorialKeys: SomeExperiments = [
  'opensearch_editorial_embedding',
  'opensearch_editorial_read',
  'opensearch_editorial_write',
];

// General utility to check for experiments
const hasExperiment = (
  experiments: AllExperiments,
  experimentKeys: SomeExperiments,
): boolean => {
  const expsParamValid = Array.isArray(experiments);
  const keysParamValid = Array.isArray(experimentKeys);
  const canCheck = expsParamValid && keysParamValid;

  if (!canCheck) {
    return false;
  }

  const check = experimentKeys.some((exp) => experiments.includes(exp));
  return check;
};

// Check for Collaboration
export const hasCollabExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, collabKeys);
};

// Check for Comments
export const hasCommentsExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, commentsKeys);
};

// Check for Collab Autosave
export const hasCollabAutosaveExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, collabAutosaveKeys);
};

// Check if Style Guide is enabled
export const hasStyleGuideExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, ['nxt_style_guide']);
};

// Check for Beta Program access
export const hasBetaProgram = (
  sc?: TSessionConfigData,
  userInfo?: GetUserMeData,
): boolean => {
  // Grant beta access if any of the following is true:
  // - account_type === 'staff' on userInfo (superuser)
  // - the 'nxt_beta_program' experiment is present
  if (userInfo?.account_type === 'staff') {
    return true;
  }
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, betaProgramKeys);
};

/**
 * Check for CopilotKit AI Assistant
 * Feature is enabled with both `nxt_beta_program` and `nxt_copilot`
 * Api key also must be present in service_keys since as
 * the <CopilotKit> components will crash without it.
 */
export const hasCopilotKitAccess = (
  sc?: TSessionConfigData,
  userInfo?: GetUserMeData,
): boolean => {
  const hasBetaAccess = hasBetaProgram(sc, userInfo);
  const experiments = sc?.experiments || [];
  const hasCopilotExp = hasExperiment(experiments, copilotKitKeys);
  const hasServiceKey = Boolean(sc?.service_keys?.copilot_kit_key);
  const isEnabled = hasBetaAccess && hasCopilotExp && hasServiceKey;
  return isEnabled;
};

/**
 * Check for nxt_copilot_local to swap copilot kit
 * endpoint to use blox endpoint instead of ck cloud.
 *
 * NOTE: It does not work from localhost:3000 due to CORS
 * you need to put builds up on pacman or vip to test.
 *
 * A separate check to enable copilot entirely
 * is done with hasCopilotKitAccess above.
 */

export const hasCopilotKitLocalExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  return hasExperiment(experiments, copilotLocalKeys);
};

/**
 * Beta program is check to enable WebMCP tools.
 * Note: still need additional checks for
 * webmcp capability browser support.
 */
export const hasWebMcpBetaAccess = (
  sc?: TSessionConfigData,
  userInfo?: GetUserMeData,
): boolean => {
  const isEnabled = hasBetaProgram(sc, userInfo);
  return isEnabled;
};

/**
 * Check for new asset save experience.
 * Feature is enabled with both:
 * `nxt_beta_program` and `nxt_save_asset_rework`
 **/
export const hasAssetSaveBetaAccess = (
  sc?: TSessionConfigData,
  userInfo?: GetUserMeData,
): boolean => {
  const hasBetaAccess = hasBetaProgram(sc, userInfo);
  const experiments = sc?.experiments || [];
  const hasSaveRework = hasExperiment(experiments, assetSaveReworkKeys);
  const isEnabled = hasBetaAccess && hasSaveRework;
  return isEnabled;
};

/**
 * Check for OpenSearch Editorial AI experiments.
 * Note: only checks the opensearch experiments
 * but the UI should also check for beta program.
 * Requires all three experiments to be enabled:
 * - opensearch_editorial_embedding
 * - opensearch_editorial_read
 * - opensearch_editorial_write
 */
export const hasOpenSearchEditorialExp = (sc?: TSessionConfigData): boolean => {
  const experiments = sc?.experiments || [];
  const hasAllExps = openSearchEditorialKeys.every((exp) => experiments.includes(exp));
  return hasAllExps;
};
